export default __webpack_public_path__ + "static/media/Putharjath's Legacy.95051407.jpg";